export default __webpack_public_path__ + "static/quattrocento-bold-0083b7a10841ab5c6a7246870d438cc5.ttf";